export default "__VITE_ASSET__aa91ae3c__"